import { Map, List, fromJS, OrderedSet } from 'immutable'
import createReucer from '@/models/createReucer'
import { RECEIVE_MESSAGE, MESSAGES_FETCHED, RECEIVE_NOTIFY, NOTIFY_FETCHED, REMOVE_MESSAGE } from './actionTypes'
import { CONVERSATIONS_FETCHED } from '../conversations/actionTypes'
import * as orderActions from '../orders/actionTypes'

const initializeState = Map({
  message_records: Map(),
  conversation_messages: Map()
})

const emptyRecord = Map({
  messages: OrderedSet(),
  hasMore: true, // 是否有更多
  last_ts: Date.now(), // 用于记录最后一条消息时间戳
  first_ts: Date.now(), // 用于记录首条消息时间戳， 这些值在获取messages和receivew_message的时候都做更新
})

export default createReucer({
  [CONVERSATIONS_FETCHED]: (state, { payload }) => {
    const { data, type } = payload
    const orders = data.map(conv => conv.order)
    const ids = orders.map(item => item._id)

    return state
      .set('conversation_messages', ids.reduce(
        (obj, id) =>
          state.hasIn(['conversation_messages', id])
            ? obj.set(id, state.getIn(['conversation_messages', id]))
            : obj.set(id, emptyRecord),
        Map()
      ))
  },

  [orderActions.ADD_ORDER]: (state, { payload }) => {
    return state
      .setIn(['conversation_messages', payload._id], Map({
        messages: OrderedSet(),
        hasMore: true, // 是否有更多
        last_ts: Date.now(), // 用于记录最后一条消息时间戳
        first_ts: Date.now(), // 用于记录首条消息时间戳
      }))
  },

  [RECEIVE_MESSAGE]: (state, { payload }) => {
    const { _id, order_id } = payload
    // 当前会话从未加载消息列表时无需处理
    if (!state.get('conversation_messages').has(order_id)) {
      console.log('order_id:', order_id, ' 不存在')
      return state
    }
    return state.withMutations(messageState => {
      const info = messageState.getIn(['conversation_messages', order_id])
      const createdAt = new Date(payload.createdAt).getTime()

      if (!info.get('last_ts') || info.get('last_ts') < createdAt) {
        messageState.setIn(['conversation_messages', order_id, 'last_ts'], createdAt)
      }

      if (!info.get('first_ts') || info.get('first_ts') > createdAt) {
        messageState.setIn(['conversation_messages', order_id, 'first_ts'], createdAt)
      }
      try {
        messageState
          .setIn(['message_records', _id], Map(payload))
          .updateIn(['conversation_messages', order_id, 'messages'], messages => {
            return messages.has(_id) ? messages : messages.add(_id)
          })
      } catch (err) {
        console.log(err)
      }
    })
  },
  [REMOVE_MESSAGE]: (state, { payload }) => {
    const { _id, order_id } = payload
    if (!state.get('conversation_messages').has(order_id)) {
      console.log('order_id:', order_id, ' 不存在')
      return state
    }
    return state.withMutations(messageState => {
      try {
        messageState
          .removeIn(['conversation_messages', order_id, 'messages', _id])
      } catch (err) {
        console.log(err)
      }
    })
  },
  [MESSAGES_FETCHED]: (state, { payload }) => {
    const { data: messages, has_more, order_id } = payload
    return state.withMutations(messageState => {
      if (messages.length) {
        const times = messages.map(msg => new Date(msg.createdAt).getTime())
        const first_ts = Math.min(times)
        const last_ts = Math.max(times)
        const info = messageState.getIn(['conversation_messages', order_id], emptyRecord)

        if (!info.get('last_ts') || info.get('last_ts') < last_ts) {
          messageState.setIn(['conversation_messages', order_id, 'last_ts'], last_ts)
        }

        if (!info.get('first_ts') || info.get('first_ts') > first_ts) {
          messageState.setIn(['conversation_messages', order_id, 'first_ts'], first_ts)
        }
      }

      messageState
        .update('message_records', records => {
          return records.merge(messages.reduce((all, msg) => {
            return all.set(msg._id, Map(msg))
          }, Map()))
        })
        .updateIn(['conversation_messages', order_id, 'messages'], (list = OrderedSet()) => {

          return list.concat(
            messages.reverse().map(msg => msg._id)
              .filter(id => !list.includes(id))
          )
        }
        )

      if (!has_more) {
        messageState.setIn(['conversation_messages', order_id, 'hasMore'], false)
      }
    })
  }
}, initializeState)
